import{__awaiter as i,__generator as r}from"./_virtual/_tslib.js";import t from"./mixins/mixins.js";import n from"./mixins/circle.js";var e=t(n).extend({name:"AmapCircleMarker",amapMeta:{initComponent:function(t,n){return i(this,void 0,void 0,(function(){return r(this,(function(i){return[2,new t.CircleMarker(n)]}))}))}}});export default e;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/circle-marker.js
// module id = null
// module chunks = 